import React from 'react';
import ComponentInView from 'src/components/common/ComponentInView/ComponentInView';
import { useAppSelector } from 'src/utils/Hooks';
import DailySpendBarChart from './DailySpendBarChartInner';

const AdDailySpendBarChart = () => {
  const app = useAppSelector((state) => state.app);
  const mainEntity = useAppSelector((state) => state.entityService.mainEntity);
  const retailer = useAppSelector((state) => state.retailer);
  const entitySearchService = useAppSelector((state) => state.entitySearchService);

  const adCampaigns = useAppSelector((state) => state.adCampaigns);
  const adPortfolios = useAppSelector((state) => state.adPortfolios);

  const entityType = mainEntity?.type;
  const entityId = mainEntity?.id;

  const entityIdTermFilter = [];

  if (entityType === 'product') {
    entityIdTermFilter.push({
      fieldName: 'stacklineSku',
      condition: 'should',
      values: [entityId]
    });
  } else if (entityType === 'brand') {
    entityIdTermFilter.push({
      fieldName: 'brandId',
      condition: 'should',
      values: [entityId]
    });
  } else if (entityType === 'category') {
    entityIdTermFilter.push({
      fieldName: 'categoryId',
      condition: 'should',
      values: [entityId]
    });
  } else if (entityType === 'subcategory') {
    entityIdTermFilter.push({
      fieldName: 'subCategoryId',
      condition: 'should',
      values: [entityId]
    });
  } else if (entityType === 'adEntity') {
    entityIdTermFilter.push({
      fieldName: 'entityId',
      condition: 'should',
      values: [entityId]
    });
  } else if (entityType === 'adPortfolio') {
    entityIdTermFilter.push({
      fieldName: 'portfolioId',
      condition: 'should',
      values: [entityId]
    });
  } else if (entityType === 'adCampaign') {
    entityIdTermFilter.push({
      fieldName: 'campaignId',
      condition: 'should',
      values: [entityId]
    });
  }

  const queryConditions = {
    termFilters: [
      {
        fieldName: 'retailerId',
        condition: 'should',
        values: [retailer.id]
      },
      ...entityIdTermFilter
    ]
  };

  return (
    <ComponentInView id="budget_pacing_chart">
      <div className="ad-performance-bar-chart">
        <DailySpendBarChart
          mainEntity={mainEntity}
          app={app}
          retailer={retailer}
          entitySearchService={entitySearchService}
          queryConditions={queryConditions}
          adCampaigns={adCampaigns}
          adPortfolios={adPortfolios}
        />
      </div>
    </ComponentInView>
  );
};

export default AdDailySpendBarChart;
